import { createAction } from '@reduxjs/toolkit';
import {
  SelectedVirtualBackground,
  VirtualBackgroundUploadAcceptedPayload,
  VirtualBackgroundUploadedPayload,
} from 'features/virtual-backgrounds/types';

export const virtualBackgroundChangeRequested = createAction<SelectedVirtualBackground>(
  'virtualBackground/backgroundChangeRequested'
);

export const customVirtualBackgroundUploadRequested = createAction<{ id: string; file: File }>(
  'virtualBackground/customVirtualBackgroundUploadRequested'
);

export const signalingVirtualBackgroundUploadAccepted =
  createAction<VirtualBackgroundUploadAcceptedPayload>(
    'signaling/virtualBackground/uploadAccepted'
  );

export const signalingVirtualBackgroundUploadRejected = createAction(
  'signaling/virtualBackground/uploadRejected'
);

export const signalingVirtualBackgroundUploaded = createAction<VirtualBackgroundUploadedPayload>(
  'signaling/virtualBackground/uploaded'
);

export const signalingVirtualBackgroundDeleted = createAction<{ id: string }>(
  'signaling/virtualBackground/deleted'
);
